import React from 'react';
import { Link } from 'react-router-dom';

const Media = () => {
    return (
        <div>
             <Link to="/" className="home-button">Home</Link> {/* Home button */}
            <h1>Media</h1>
        </div>
    );
};

export default Media;
